import styled, { gapSize } from 'theme';

export const Rotate = styled('div')`
  transform: rotate(0.75turn);

  svg {
    margin: 0 0 ${() => gapSize(1)} 0;
  }
`;
